import { combineReducers } from '@reduxjs/toolkit';
import { gameInfoSlice } from 'modules/stream/store/game-info/game-info';
import { overlaySlice } from './overlay/overlay';
import { timeSlice } from './time/time';

const overlayReducer = combineReducers({
  overlay: overlaySlice.reducer,
  gameInfo: gameInfoSlice.reducer,
  time: timeSlice.reducer,
});

export default overlayReducer;
